//import axios from 'axios';
import { createApp } from 'vue';
import OrdersApp from './components/OrdersApp.vue';
import ScheduleApp from './components/ScheduleApp.vue';
//import router from './router';
import store from './store';

/*
const ordersAppEl = document.querySelector('#npp-orders-app');
if (ordersAppEl) {
    createApp(OrdersApp).mount(ordersAppEl);
}

const scheduleAppEl = document.querySelector('#npp-schedule-app');
if (scheduleAppEl) {
    createApp(ScheduleApp).use(router).use(store).mount(scheduleAppEl);
}
*/

const initializeApp = async () => {
    const ordersAppEl = document.querySelector('#npp-orders-app');
    if (ordersAppEl) {
        createApp(OrdersApp).mount(ordersAppEl);
    }
  
    const scheduleAppEl = document.querySelector('#npp-schedule-app');
    if (scheduleAppEl) {
        const router = await import('./router');
        createApp(ScheduleApp).use(router.default).use(store).mount(scheduleAppEl);
    }
};

initializeApp();